// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p5SJC","left":"styles_left__qmdze","right":"styles_right__lk9ZY","alert":"styles_alert__3Vxre"};